var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignShortcutActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#9F7AEA",
    fillOpacity: 0.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3333_18857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5C12.5 14.7044 12.8161 13.9413 13.3787 13.3787C13.9413 12.8161 14.7044 12.5 15.5 12.5H24.5C25.2956 12.5 26.0587 12.8161 26.6213 13.3787C27.1839 13.9413 27.5 14.7044 27.5 15.5V24.5C27.5 25.2956 27.1839 26.0587 26.6213 26.6213C26.0587 27.1839 25.2956 27.5 24.5 27.5H15.5C14.7044 27.5 13.9413 27.1839 13.3787 26.6213C12.8161 26.0587 12.5 25.2956 12.5 24.5V15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 19.25C18.4105 19.25 19.25 18.4105 19.25 17.375C19.25 16.3395 18.4105 15.5 17.375 15.5C16.3395 15.5 15.5 16.3395 15.5 17.375C15.5 18.4105 16.3395 19.25 17.375 19.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8945 20.466L15.5 27.5002H24.5997C25.3689 27.5002 26.1066 27.1947 26.6505 26.6508C27.1944 26.1069 27.5 25.3692 27.5 24.6V24.5002C27.5 24.1507 27.3688 24.0165 27.1325 23.7577L24.11 20.4615C23.9691 20.3078 23.7978 20.1852 23.6069 20.1015C23.416 20.0177 23.2097 19.9747 23.0013 19.9751C22.7928 19.9755 22.5867 20.0194 22.3962 20.1039C22.2056 20.1884 22.0347 20.3117 21.8945 20.466Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3333_18857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignShortcutActive);
export default __webpack_public_path__ + "static/media/DesignShortcutActive.3558ae8ed3d241b32923c5c7355c8ad4.svg";
export { ForwardRef as ReactComponent };